import { render } from "./Chat_Attachments.vue?vue&type=template&id=e4ed76be"
import script from "./Chat_Attachments.vue?vue&type=script&lang=js"
export * from "./Chat_Attachments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__